import React, { useState } from 'react';
import painelApi, { salvarSessaoPainel } from '../services/painelApi';
import { BRAND_NOME } from '../brand';

export default function PainelLogin({ onEntrar }) {
  const [identificador, setIdentificador] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  const entrar = async (e) => {
    e.preventDefault();
    if (!identificador || !senha) return;
    setEnviando(true);
    setErro('');
    try {
      const { data } = await painelApi.post('/painel-clientes/login', { identificador, senha });
      salvarSessaoPainel(data.token, data.usuario);
      onEntrar(data.usuario);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao entrar.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0f172a', fontFamily: 'inherit',
    }}>
      <form onSubmit={entrar} style={{
        background: '#fff', borderRadius: 8, padding: '32px 36px', width: 340,
        boxShadow: '0 10px 40px rgba(0,0,0,.35)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 22 }}>
          <div style={{ width: 34, height: 34, borderRadius: 8, background: '#16a34a', color: '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15 }}>E+</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#0f172a' }}>{BRAND_NOME}</div>
            <div style={{ fontSize: 11, color: '#64748b' }}>Painel de Clientes</div>
          </div>
        </div>

        <label style={{ fontSize: 12, fontWeight: 600, color: '#334155' }}>Usuário</label>
        <input autoFocus value={identificador} onChange={e => setIdentificador(e.target.value)}
          placeholder="E-mail ou nome de usuário"
          style={{ width: '100%', boxSizing: 'border-box', height: 38, padding: '0 10px', margin: '4px 0 14px',
            border: '1px solid #cbd5e1', borderRadius: 5, fontSize: 14 }} />

        <label style={{ fontSize: 12, fontWeight: 600, color: '#334155' }}>Senha</label>
        <input type="password" value={senha} onChange={e => setSenha(e.target.value)}
          style={{ width: '100%', boxSizing: 'border-box', height: 38, padding: '0 10px', margin: '4px 0 18px',
            border: '1px solid #cbd5e1', borderRadius: 5, fontSize: 14 }} />

        {erro && <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', color: '#b91c1c',
          borderRadius: 5, padding: '8px 10px', fontSize: 12.5, marginBottom: 14 }}>{erro}</div>}

        <button type="submit" disabled={enviando} style={{
          width: '100%', height: 40, background: '#0f172a', color: '#fff', border: 'none',
          borderRadius: 5, fontSize: 14, fontWeight: 600, cursor: enviando ? 'default' : 'pointer',
          opacity: enviando ? 0.7 : 1,
        }}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
